<template>
    <div>
        <div class="col-md-12 control-section">
            <!-- <div class="content-wrapper"> -->
                <ejs-schedule v-if="carregou"
                    id='Schedule' 
                    ref="ScheduleObj" 
                    height="950px" 
                    :currentView='currentView' 
                    :selectedDate='selectedDate' 
                    :eventSettings='eventSettings'
                    :eventRendered="oneventRendered"
                    :startHour="startHour"
                    :endHour="endHour"
                    :popupOpen="onPopupOpen"
                    :created="onCreate"
                    :actionComplete="onActionComplete"
                    :agendaDaysCount="30"
                >
                    <e-views>
                        <e-view option="Day" startHour="07:00" endHour="18:00"></e-view>
                        <e-view option="Week" startHour="09:00" endHour="19:00" :timeScale='timeScale' :showWeekend="showWeekend"></e-view>
                        <e-view option="Month" :group="group" :eventTemplate='monthEventTemplate'></e-view>
                        <!-- <e-view option="Agenda" :eventTemplate='agendaEventTemplate'></e-view> -->
                    </e-views>
                    <e-resources>
                        <e-resource field='GroupId' title='Funcionário' name='Owners' :dataSource='groupData' textField='GroupText' idField='GroupId'
                            colorField='GroupColor'>
                        </e-resource>
                    </e-resources>
                </ejs-schedule>
            <!-- </div> -->
        </div>

    </div>
</template>
<script>
    // import Pusher from "pusher-js"; // import Pusher
    import axios from "axios";
    import Vue from "vue";
    import { Internationalization, extend, createElement } from '-syncfusion/ej2-base';
    import { SchedulePlugin, Day, Week, Month, Agenda, View, Resize, DragAndDrop } from "-syncfusion/ej2-vue-schedule";
    import { DropDownList } from "-syncfusion/ej2-dropdowns";
    import { Input } from "-syncfusion/ej2-inputs";
    import { DataManager, WebApiAdaptor } from '-syncfusion/ej2-data';
    Vue.use(SchedulePlugin);

    var instance = new Internationalization();
    var monthVue = Vue.component("month-eventTemplate", {
        template: '<div class="subject">{{data.Subject}}</div>',
        data() {
            return {
                data: {}
            };
        }
    });

    var agendaVue = Vue.component("agenda-eventTemplate", {
        template: '<div><div class="subject">{{data.Subject}}</div><div v-if="data.Description !== null && data.Description !== undefined" class="group">{{data.Description}}</div>' +
        '<div class="location">{{getTimeString(data.StartTime)}}, <span v-if="data.City!== null && data.City!==undefined">{{data.City}}</span></div></div>',
        data() {
            return {
                data: {}
            };
        },
        methods: {
            getTimeString: function (value) {
                return instance.formatDate(value, { skeleton: 'Hm' });
            }
        }
    });

    export default Vue.extend({
        data: function () {
            return {
                carregou: false,
                resourceData: [],
                // eventSettings: { dataSource: extend([], fifaEventsData, null, true) },
                selectedDate: new Date(),
                showWeekend: false,
                currentView: 'Day',
                timeScale: { interval: 60, slotCount: 4 },
                agendaEventTemplate: function () {
                    return { template: agendaVue }
                },
                monthEventTemplate: function (e) {
                    return { template: monthVue };
                },
                group: { resources: ['Owners'] },
                groupData: [
                    // { GroupText: 'Group A', GroupId: 1, GroupColor: '#1aaa55' },
                    // { GroupText: 'Group B', GroupId: 2, GroupColor: '#357cd2' }
                ],
                startHour: "08:00",
                endHour: "20:00",
                servicos: [],
                clientes: []
            }
        },
        created() {
            this.getNovoAgendamento();
            this.getServicos();
            this.getClientes();
            this.getFuncionario();
            this.atualizaAgendamento();
        },
        provide: {
            schedule: [Day, Week, Month, Agenda, Resize, DragAndDrop]
        },
        computed: {
            eventSettings: function() {
            return { dataSource: this.generateData() };
            }
        },
        methods: {
            oneventRendered: function (args) {
                let scheduleObj = this.$refs.ScheduleObj;
                let categoryColor = args.data.CategoryColor;
                if (!args.element || !categoryColor) {
                    return;
                }
                if (scheduleObj.ej2Instances.currentView === 'Agenda') {
                    (args.element.firstChild).style.borderLeftColor = categoryColor;
                } else {
                    args.element.style.backgroundColor = categoryColor;
                }

            },
            atualizaAgendamento() {
                axios
                .get("https://tprint.herokuapp.com/api/agenda")
                .then(response => {
                response.data.forEach(element => {
                    console.log('element => ', element)
                    if(element.confirmado) {
                        this.resourceData.push({
                            Cliente: element.cliente.fb_id,
                            NomeCliente: `${element.cliente.nome} ${element.cliente.sobrenome} (${element.cliente.fb_id})` ,
                            Telefone: element.cliente.contato,
                            Servicos: element.servico_id,
                            Subject: `${element.servico.nome} <br /> Cliente: ${element.cliente.nome}`,
                            StartTime: `${element.data}T${element.hr_inicio}`,
                            EndTime: `${element.data}T${element.hr_termino}`,
                            IsAllDay: false,
                            StartTimezone: null,
                            EndTimezone: null,
                            GroupId: element.funcionario.id,
                            Description: element.enderecos.length > 0 ? 
                                        `Endereço:      ${element.enderecos[0].endereco.rua}, ${element.enderecos[0].endereco.numero}
                            ${element.enderecos[0].endereco.bairro} 
                            ${element.enderecos[0].endereco.cidade} 
                            ${element.enderecos[0].endereco.cep} ` : 
                                        'Irá levar no local',
                            Id: element.id,
                            RecurrenceException: null,
                            RecurrenceID: null
                        });
                    }
                });
                this.carregou = true;
                });
            },
            getNovoAgendamento() {
                Pusher.logToConsole = true;

                var pusher = new Pusher('6846a7777c4cdce67915', {
                    cluster: 'us2',
                    forceTLS: true
                });

                var channel = pusher.subscribe(`agenda${window.localStorage.getItem('FB_ID')}`);
                channel.bind('novo', (data) => {
                    // alert(JSON.stringify(data));
                    this.atualizaAgendamento();
                });
            },
            onCreate(a) {
            // console.log("oncreate => ", a);
            },
            onActionComplete(a) {
                console.log("onActionComplete => ", (a));
                if(a.requestType === 'eventRemoved' || a.requestType === 'eventChanged') {
                    this.confirmaNotificacao(a.data.Cliente ? a.data.Cliente : a.data[0].Cliente)
                }
            },
            confirmaNotificacao (fb_id) {
                this.$swal({
                    title: 'Mensagem de Notificação',
                    html: '<textarea class="form-control textarea" rows="3" id="txtNotify" placeholder="Notifique seu cliente sobre a alteração."></textarea>',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Enviar'
                }).then((result) => {
                    if (result.value) {
                        let textarea = document.getElementById('txtNotify').value
                        this.notificarCliente(textarea, fb_id)
                    }
                })
            },
            notificarCliente (msg, fb_id) {
                let url= `${this.$store.state.api_bot}notificar`
                axios.post(url, {
                    'fb_id': fb_id,
                    'msg': msg,
                })
                this.$swal({
                    position: 'top-end',
                    type: 'success',
                    title: 'Clientes Notificados',
                    showConfirmButton: false,
                    timer: 1500
                });
            },
            generateData: function() {
                var collections = [];
                var dataCollections = [this.resourceData];
                for (var i = 0; i < dataCollections.length; i++) {
                    collections = collections.concat(dataCollections[i]);
                }
                return collections;
            },
            onPopupOpen: function(args) {
                console.log('args ==> ', args)
                if (args.type === "Editor") {
                    // Create required custom elements in initial time
                    if (!args.element.querySelector(".custom-field-row")) {

                        /*      ROWS     */

                        let rowLblCliente = createElement("div", { className: "custom-field-row" });
                        let row = createElement("div", { className: "custom-field-row" });
                        let rowLblTel = createElement("div", { className: "custom-field-row" });
                        let row2 = createElement("div", { className: "custom-field-row" });
                        let rowTel = createElement("div", { className: "custom-field-row" });

                        let formElement = args.element.querySelector(".e-schedule-form");

                        formElement.firstChild.insertBefore(
                            rowLblCliente,
                            args.element.querySelector(".e-resources-row")
                        );

                        formElement.firstChild.insertBefore(
                            row,
                            args.element.querySelector(".e-resources-row")
                        );

                        formElement.firstChild.insertBefore(
                            rowLblTel,
                            args.element.querySelector(".e-resources-row")
                        );

                        formElement.firstChild.insertBefore(
                            row2,
                            args.element.querySelector(".e-resources-row")
                        );

                        formElement.firstChild.insertBefore(
                            rowTel,
                            args.element.querySelector(".e-resources-row")
                        );

                        /*      CONTAINER     */

                        let containerLbl = createElement("div", {
                            className: "custom-field-container"
                        });


                        let container = createElement("div", {
                            className: "custom-field-container"
                        });
                        
                        let containerLblTel = createElement("div", {
                            className: "custom-field-container"
                        });

                        let container2 = createElement("div", {
                            className: "custom-field-container"
                        });

                        let container3 = createElement("div", {
                            className: "custom-field-container"
                        });

                        /*      INPUT     */

                        let inputEle = createElement("input", {
                            className: "e-field",
                            attrs: { name: "Cliente" }
                        });

                        let inputEle2 = createElement("input", {
                            className: "e-field",
                            attrs: { name: "Telefone" }
                        });

                        let inputEle3 = createElement("input", {
                            className: "e-field disabled",
                            attrs: { name: "Servicos" }
                        });

                        let labelCliente = createElement("label", {
                            className: 'e-float-text e-label-top',
                            innerHTML: 'Cliente',
                            styles: 'position: relative'
                        });

                        let labelTel = createElement("label", {
                            className: 'e-float-text e-label-top',
                            innerHTML: 'Telefone',
                            styles: 'position: relative'
                        });

                        containerLbl.appendChild(labelCliente);
                        container.appendChild(inputEle);
                        containerLblTel.appendChild(labelTel);
                        container2.appendChild(inputEle2);
                        container3.appendChild(inputEle3);

                        rowLblCliente.appendChild(containerLbl);
                        row.appendChild(container);
                        rowLblTel.appendChild(containerLblTel);
                        row2.appendChild(container2);
                        rowTel.appendChild(container3);

                        var input = Input.createInput({
                            floatLabelType: 'Always',
                            element: formElement,
                            placeholder: "Serviço",
                            value: args.data.Servicos,
                        })

                        var input2 = Input.createInput({
                            floatLabelType: 'Always',
                            element: formElement,
                            placeholder: "Cliente",
                            value: args.data.NomeCliente,
                        })

                        var input3 = Input.createInput({
                            floatLabelType: 'Always',
                            element: formElement,
                            placeholder: "Telefone",
                            value: args.data.Telefone,
                        })

                        // inputEle.setAttribute("name", "Cliente");
                        labelCliente.setAttribute("style", "position: relative");
                        labelTel.setAttribute("style", "position: relative");

                        var dropDownList = new DropDownList({
                            dataSource: this.servicos,
                            fields: { text: "text", value: "value" },
                            value: args.data.Servicos,
                            floatLabelType: "Always",
                            placeholder: "Serviço"
                        });
                        dropDownList.appendTo(inputEle3);
                        inputEle3.setAttribute("name", "Servicos");

                        // var dropDownList2 = new DropDownList({
                        //     dataSource: this.clientes,
                        //     fields: { text: "text", value: "value" },
                        //     value: args.data.Cliente,
                        //     floatLabelType: "Always",
                        //     placeholder: "Cliente"
                        // });
                        // dropDownList2.appendTo(inputEle);
                        inputEle.setAttribute("id", "input-cliente");
                        inputEle.setAttribute("style", "margin-bottom: 10px");

                        inputEle2.setAttribute("id", "input-telefone");
                        inputEle2.setAttribute("style", "margin-bottom: 10px");

                        document.getElementById('input-cliente').value = args.data.NomeCliente
                        document.getElementById('input-telefone').value = args.data.Telefone
                    }
                }
            },
            getServicos() {
                axios
                .get("https://tprint.herokuapp.com/api/servicos")
                .then(response => {
                    response.data.forEach(element => {
                        this.servicos.push({
                            text: element.nome,
                            value: element.id
                        });
                    });
                    console.log(this.servicos)

                });
            },
            getFuncionario() {
                axios
                .get("https://tprint.herokuapp.com/api/funcionarios")
                .then(response => {
                    response.data.forEach(element => {
                        this.groupData.push({
                            GroupText: element.nome,
                            GroupId: element.id,
                            GroupColor: '#3C8DBC'
                        });
                    });
                }); 
            },
            getClientes() {
                axios
                .get("https://tprint.herokuapp.com/api/clientes")
                .then(response => {
                    response.data.forEach(element => {
                    this.clientes.push({
                        text: element.nome,
                        value: element.fb_id
                    });
                    });
                });
            }
        }
    });

</script>
<style>
    .e-schedule .e-agenda-view .e-appointment .subject {
        font-size: 14px;
    }

    .e-schedule .e-agenda-view .e-appointment .group {
        font-size: 12px;
        font-weight: 500;
    }

    .e-schedule .e-agenda-view .e-appointment .location {
        font-size: 12px;
    }

    .e-schedule .e-date-header-wrap .e-resource-cells {
        font-weight: 500;
    }

    .e-schedule .e-month-view .e-appointment .e-appointment-details {
        padding: 1px;
        padding-left: 3px;
    }
@import "../../../node_modules/-syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/-syncfusion/ej2-buttons/styles/material.css";
@import "../../../node_modules/-syncfusion/ej2-calendars/styles/material.css";
@import "../../../node_modules/-syncfusion/ej2-dropdowns/styles/material.css";
@import "../../../node_modules/-syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/-syncfusion/ej2-navigations/styles/material.css";
@import "../../../node_modules/-syncfusion/ej2-popups/styles/material.css";
@import "../../../node_modules/-syncfusion/ej2-vue-schedule/styles/material.css";
</style>


// WEBPACK FOOTER //
// Calendario.vue?3064e398